import {useRef} from 'react';
import {useSelector, useStore} from 'react-redux';
import {pluralize} from '~/common/utils';
import {animateRSVPButton} from '~/ViewInvitation/common/StickyRSVP';
import {likePost, unlikePost} from '~/ViewInvitation/reducers/apiActions';
import {Typography} from '~library/atoms/Typography';
import {FavoritesFillIcon} from '~library/svg/FavoritesFillIcon';
import {FavoritesLineIcon} from '~library/svg/FavoritesLineIcon';
import {cloud, rose} from '~libSass/base/_exports.sass';

export const LikeButton = (props) => {
  const store = useStore();
  const processing = useRef(false);
  const {postId, userId, post, showCount = true, dataQaId} = props;
  const {likedBy} = post;

  const likedByThisUser = Array.isArray(likedBy)
    ? likedBy.includes(userId)
    : Object.keys(likedBy).includes(userId);
  const likeCount = likedBy.length || Object.keys(likedBy).length;

  const hasRSVPd = useSelector((state) => state.rsvp?.hasRsvpd ?? false);

  const toggleLike = async () => {
    processing.current = true;
    if (hasRSVPd) {
      if (likedByThisUser) {
        store.dispatch(unlikePost(postId));
      } else {
        store.dispatch(likePost(postId));
      }
    } else {
      animateRSVPButton();
    }
    processing.current = false;
  };

  const likeButtonText = () => {
    if (showCount) {
      return pluralize('Like', likeCount);
    }
    return likedByThisUser ? 'Unlike' : 'Like';
  };

  return (
    <button
      onClick={(e) => !processing.current && toggleLike(e)}
      className="unstyled-button wic__guest-post-interact-button"
      data-qa-id={dataQaId}
      type="button"
    >
      {likedByThisUser
        ? <FavoritesFillIcon ratio={0.375} color={rose} />
        : <FavoritesLineIcon ratio={0.375} color={cloud} />}
      <Typography variant="paragraph4">{likeButtonText()}</Typography>
    </button>
  );
};
